"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var IntlService_1 = require("../Intl/IntlService");
var LocalizationService_1 = require("../Localization/LocalizationService");
/** @hidden */
exports.GlobalizationContext = React.createContext({
    intl: new IntlService_1.IntlService('en'),
    localization: new LocalizationService_1.LocalizationService()
});
//# sourceMappingURL=GlobalizationContext.js.map